<template>
  <div id="app" style="background-color: rgba(235, 235, 235, 0.08)">
    <router-view/>
    <!-- <router-view name="main"/> -->
  </div>
</template>

<script>
// 移动端误操作屏蔽：长按菜单（安卓右键/选择）、iOS 捏合缩放。
// 桌面端不受影响（按视口宽度判定）；下拉刷新由 CSS overscroll-behavior 关闭。
const MOBILE_WIDTH = 768;

function isMobileNow() {
  return window.innerWidth <= MOBILE_WIDTH;
}

function blockMobileContextmenu(e) {
  if (isMobileNow()) e.preventDefault();
}

function blockMobileGesture(e) {
  if (isMobileNow()) e.preventDefault();
}

export default {
  name: 'app',
  data() {
    return {
    }
  },
  mounted() {
    document.addEventListener('contextmenu', blockMobileContextmenu);
    // iOS Safari 自 iOS 10 起无视 user-scalable=no，捏合缩放只能靠 gesture 事件拦截
    document.addEventListener('gesturestart', blockMobileGesture);
    document.addEventListener('gesturechange', blockMobileGesture);
  },
  beforeDestroy() {
    document.removeEventListener('contextmenu', blockMobileContextmenu);
    document.removeEventListener('gesturestart', blockMobileGesture);
    document.removeEventListener('gesturechange', blockMobileGesture);
  }
}
</script>

<style>
/* ========== 移动端适配：CSS自定义属性 ========== */
:root {
  --mobile-header-h: 30px;
  --mobile-footer-h: 110px;
  --mobile-compass-size: 100px;
  --safe-area-bottom: env(safe-area-inset-bottom, 0px);
}

/* ========== 移动端视口锁定 ========== */
@media (max-width: 768px) {
  html, body {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
    -webkit-overflow-scrolling: none;
    touch-action: manipulation;
    /* 禁下拉刷新/边缘回弹（浏览器手势防误操作） */
    overscroll-behavior: none;
    position: fixed;
    top: 0;
    left: 0;
    color-scheme: light only;
  }

  #app {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
    position: relative;
  }

  /* 全局禁止文本选择（游戏HUD风格） */
  * {
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    /* 全元素生效：禁双击缩放（保留平移/滚动，弹窗内滚动不受影响） */
    touch-action: manipulation;
    /* iOS 长按呼出预览/存储面板一并禁掉 */
    -webkit-touch-callout: none;
  }

  input, textarea {
    -webkit-user-select: text;
    user-select: text;
  }
}

/* ========== 全局 el-dialog 移动端适配 ========== */
@media (max-width: 768px) {
  /* 关键修复：dialog 需 append 到 body，否则会被 #app 的 fixed/overflow 容器截断 */
  .el-dialog__wrapper {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 100% !important;
    overflow: hidden;
    z-index: 600 !important;
  }
  /* 遮罩在弹窗之下，避免 PopupManager 动态分配的高 z-index 覆盖弹窗内容 */
  .v-modal {
    z-index: 595 !important;
  }

  .el-dialog__wrapper .el-dialog {
    width: 92% !important;
    max-width: 480px !important;
    margin: 8vh auto 0 !important;
    max-height: 80vh;
    max-height: 80dvh;
    display: flex;
    flex-direction: column;
    border-radius: 8px !important;
  }

  .el-dialog__wrapper .el-dialog .el-dialog__header {
    flex-shrink: 0;
    padding: 8px 12px;
  }

  /* 关闭按钮 - 标题绿 #72b653 的互补色：玫红 */
  .el-dialog__wrapper .el-dialog .el-dialog__headerbtn {
    top: 8px !important;
    right: 8px !important;
    width: 34px !important;
    height: 34px !important;
    border-radius: 50%;
    background: #b65283;
    border: 2px solid #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
    display: flex !important;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }
  .el-dialog__wrapper .el-dialog .el-dialog__headerbtn:hover {
    background: #c76397;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.5);
  }
  .el-dialog__wrapper .el-dialog .el-dialog__headerbtn:active {
    background: #a04273;
    transform: scale(0.95);
  }
  .el-dialog__wrapper .el-dialog .el-dialog__headerbtn .el-dialog__close {
    color: #fff !important;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
  }

  .el-dialog__wrapper .el-dialog .el-dialog__body {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 10px 12px;
  }
}

/* 移动端通知弹窗 z-index 高于 dialog */
@media (max-width: 768px) {
  .el-notification,
  .el-message {
    z-index: 700 !important;
  }
  /* MessageBox (确认框) 移动端适配 */
  .el-message-box__wrapper {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 601 !important;
  }
  .el-message-box {
    width: 85% !important;
    max-width: 360px !important;
    margin: 15vh auto 0 !important;
  }
}

/* ========== 桌面端保留原样式 ========== */
/*调整节点中背包显示宽度*/
.pocket .wrap,
.taskdiv .wrap {
    margin:auto;
}
/* el-col没有内容时height=0 被浏览器认为这个元素是不可见的。
解决方式是全局给el-col加个min-height */
.el-col {
  min-height: 1px
}
/* 道具效果行的多行展示：MessageBox/Notification 对字符串 message 是纯文本插值，
   文案里的 \n 默认塌缩成空格。带 effect-multiline 的弹层按 pre-line 还原换行
   （不用 dangerouslyUseHTMLString，保持零注入面）。 */
.el-message-box.effect-multiline .el-message-box__message {
  white-space: pre-line;
}
.el-notification.effect-multiline .el-notification__content p {
  white-space: pre-line;
}
</style>
